import WexPage from './WexPage';

import Testimonies from '../components/testimonies';
import LandingBackground from '../components/landing-background';
import LocaleSuggestion from "../components/locale-suggestion";

/**
 * Site specific stuffs.
 */
export default class extends WexPage {
    init() {
        // Locale suggestion configuration.
        window.localSuggestionGetUrl = (lang) => {
            return this.app.getDomain(lang);
        };

        super.init();

        // Components.
        this.initComponent(
            document.getElementsByTagName('header')[0],
            LandingBackground
        );

        // Detect feedback blocks.
        document
            .querySelectorAll('.testimonies')
            .forEach((el) => this.initComponent(el, Testimonies));

        // Initialize locale select element
        this.app.vue.buildSingleComponent(
            document.getElementById('select-locale'),
            require('./../vue/SelectLocale.vue')
        );

        // Initialize timezone menu label
        this.initUserTimezone();

        // Initialize timezone select element
        this.app.vue.buildSingleComponent(
            document.getElementById('select-timezone'),
            require('./../vue/SelectTimezone.vue')
        );
        if (document.getElementById('select-timezone-modal')) {
            this.app.vue.buildSingleComponent(
                document.getElementById('select-timezone-modal'),
                require('./../vue/SelectTimezone.vue')
            );
        }

        // Initialize currency menu label
        this.initUserCurrency();

        // Initialize currency select element
        this.app.vue.buildSingleComponent(
            document.getElementById('select-currency'),
            require('./../vue/SelectCurrency.vue')
        );
        if (document.getElementById('select-currency-modal')) {
            this.app.vue.buildSingleComponent(
                document.getElementById('select-currency-modal'),
                require('./../vue/SelectCurrency.vue')
            );
        }

        // Burger menu.
        document
            .querySelector('#header-mobile-menu a')
            .addEventListener('click', (e) => {
                if (
                    !document
                        .getElementById('menu-links')
                        .classList.toggle('opened')
                ) {
                    // Do not scroll down when menu is closing.
                    e.preventDefault();
                }
            });

        this.initComponent(
          '#locale-suggestion',
          LocaleSuggestion);
    }

    initAllComponents(selector, Component) {
        // Init all accordions.
        document.querySelectorAll(selector).forEach((el) => {
            this.initComponent(el, Component);
        });
    }

    initUserTimezone() {
        const timezone = this.app.locale.getUserTimezone();
        const timezoneDateNow = this.app.lib.moment().tz(timezone);
        const timezoneUtcOffset = Math.round(timezoneDateNow.utcOffset() / 60);

        let timezoneUtcOffsetLabel = 'UTC';
        timezoneUtcOffsetLabel +=
            timezoneUtcOffset >= 0
                ? '+' + timezoneUtcOffset
                : timezoneUtcOffset;
        document.getElementById('user-timezone-menu-label').innerHTML =
            timezoneUtcOffsetLabel;
    }

    initUserCurrency() {
        document.getElementById('user-currency-menu-label').innerHTML =
            this.app.getSelectedCurrency().code;
    }
}
